import { render, staticRenderFns } from "./MoyasarRedirect.vue?vue&type=template&id=b4336044"
import script from "./MoyasarRedirect.vue?vue&type=script&lang=js"
export * from "./MoyasarRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports